import { http } from "@/utils/axios";

/**
 * @msg: 获取综合测验列表数据
 */
export function getComprehensiveTestList(data) {
    return http({
        url: http.baseUrl('elExamsPaper/getGeneralTestList'),
        method: 'post',
        params: http.params(data),
        data
    })
}


/**
 * @msg: 获取考试安排列表数据
 */
export function getExamArrangementList(params) {
    return http({
        url: http.baseUrl('zkolTeacherCourseBatch/getTeacherCourseBatchForTestList'),
        method: 'get',
        params
    })
}

/**
 * @msg: 获取学员列表数据
 */
export function getStudentPageList(data) {
    return http({
        url: http.baseUrl('zkolTeacherCourseBatch/getStudentPage'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获取监考管理列表数据
 */
export function getExamsTestList(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getExamsUsersWithTourForTest'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获监考管理时间
 */
export function getExamsPaperById(data) {
    return http({
        url: http.baseUrl('elExamsPaper/getByExamsPaperByIdAndBatchId'),
        method: 'get',
        params: http.params(data)
    })
}